import Button, { ButtonProps } from "@mui/material/Button";
import { styled } from "@mui/material/styles";

interface ButtonPropsType extends ButtonProps {
  buttonTitle: string;
}

const createButtonStyle = ({ variant, color }: ButtonProps) =>
  styled(Button)(({ theme }) => {
    const themeColor =
      theme.color && theme.color[color as keyof typeof theme.color];

    return {
      textTransform: "capitalize",
      fontFamily: theme?.font?.fontFamily.primary,
      fontSize: variant === "text" ? "0.9rem" : "0.7rem",
      py: 1.2,
      minHeight: "2.5rem",
      minWidth: "8rem",
      fontWeight: "600",
      backgroundColor: variant === "contained" ? themeColor : "transparent",
      color: variant === "contained" ? theme.color?.background : themeColor,
      border:
        variant === "outlined"
          ? `${theme.border?.xsmall}${themeColor}`
          : "none",
      "&:hover": {
        color:
          variant === "text"
            ? theme?.color?.[
                color === "error"
                  ? "error"
                  : color === "secondary"
                  ? "primary"
                  : "secondary"
              ]
            : variant === "outlined"
            ? theme?.color?.[
                color === "error"
                  ? "error"
                  : color === "secondary"
                  ? "primary"
                  : "secondary"
              ]
            : "",
        backgroundColor:
          variant === "contained"
            ? theme?.color?.[
                color === "error"
                  ? "error"
                  : color === "secondary"
                  ? "primary"
                  : "secondary"
              ]
            : "transparent",
        border:
          variant === "outlined"
            ? `${theme.border?.xsmall} ${
                theme?.color?.[
                  color === "error"
                    ? "error"
                    : color === "secondary"
                    ? "primary"
                    : "secondary"
                ]
              }`
            : "none",
      },
    };
  });

export const CommonButton = (props: ButtonPropsType) => {
  const { buttonTitle } = props;

  const ButtonStyle = createButtonStyle(props);

  return <ButtonStyle {...props}>{buttonTitle}</ButtonStyle>;
};
